var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown iframe",attrs:{"id":`iframe-${_vm.number}`},domProps:{"innerHTML":_vm._s(_vm.value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }